import React from "react";
import CardGame from "../../assets/miniGame.png";
import BlackPlay from "../../assets/blackPlay.png";

const MiniGameCard = ({ item }) => {
  return (
    <div className="flex h-full flex-col justify-center md:justify-normal md:flex-row items-center cursor-pointer relative transition-transform duration-300 ease-in-out transform hover:scale-105">
      <img
        src={item}
        className="   object-cover w-[150px]  md:w-[300px] h-[150px] rounded-xl"
        alt="Mini Game"
      />
      <button className="absolute bottom-3 right-4 z-50">
        <img src={BlackPlay} className="w-6 h-6" alt="Play Icon" />
      </button>
    </div>
  );
};

export default MiniGameCard;
